import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=6cd100cc&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"
import style0 from "./payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd100cc')) {
      api.createRecord('6cd100cc', component.options)
    } else {
      api.reload('6cd100cc', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=6cd100cc&", function () {
      api.rerender('6cd100cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/payment.vue"
export default component.exports